import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import SilicOneBrochures from '../views/SilicOneBrochures.vue'
import Find from '../views/Find.vue'
import FindResults from '../views/FindResults.vue'
import CalculateResults from '../views/CalculateResults.vue'

Vue.use(Router)

const routes = [
    {
        path: '/',
        component: Home
    },
    {
        path: '/find',
        name: 'find',
        component: Find
    },
    {
        path: '/silic-one-brochures',
        name: 'brochures',
        component: SilicOneBrochures
    },
    {
        path: '/find_results',
        name: 'find_results',
        component: FindResults
    },
    {
        path: '/calculate',
        name: 'calculate',
        component: Find
    },
    {
        path: '/calculate_results',
        name: 'calculate_results',
        component: CalculateResults
    },
    // {
    //     path: '/Paint_Manual_UK.pdf',
    //     redirect: 'https://www.hempelyacht.com/en-gb'
    // },
    {
        path: '/Paint_Manual_UK.pdf',
        redirect: () => {
            window.location.href = 'https://www.hempelyacht.com/en-gb'
        }
    }
]

const router = new Router({
    mode: 'history',
    routes: routes.map(route => ({
        path: route.path,
        name: route.name,
        component: route.component || Home
    }))

    /* scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(savedPosition || { x: 0, y: 0 })
            }, 3000)
        })
    } */
})

export default router
